<template>
	<div>
		<div class="form__question">
			<img class="quiz__img" src="img/question.png" alt="">
			<div class="form__questions__body">
				<p>{{questionIndex}}. {{question.question}}</p>
				<ul class="test__sub-item quiz__options">
					<li class="test__option">
						<label class="option">
							<input 
								:value="question.option_a"
								:name="`question-${question.id}`" 
								v-model="answer"
								type="radio"
								@click="setAnswer(question.option_a, 'option_a')">
							<span class="text">{{question.option_a}}</span>
							<span class="radio"></span>
						</label>
					</li>
					<li class="test__option">
						<label class="option">
							<input 
								:value="question.option_b"
								:name="`question-${question.id}`" 
								v-model="answer"
								type="radio"
								@click="setAnswer(question.option_b, 'option_b')">
							<span class="text">{{question.option_b}}</span>
							<span class="radio"></span>
						</label>
					</li>
					<li class="test__option">
						<label class="option">
							<input 
								:value="question.option_c"
								:name="`question-${question.id}`" 
								v-model="answer"
								type="radio"
								@click="setAnswer(question.option_c, 'option_c')">
							<span class="text">{{question.option_c}}</span>
							<span class="radio"></span>
						</label>
					</li>
					<li class="test__option">
						<label class="option">
							<input 
								:value="question.option_d"
								:name="`question-${question.id}`" 
								v-model="answer"
								type="radio"
								@click="setAnswer(question.option_d, 'option_d')">
							<span class="text">{{question.option_d}}</span>
							<span class="radio"></span>
						</label>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import eventHub from '../../utils/eventhub';

export default {
	name: 'Question',
	props: {
		question: {
			type: Object,
			default() {
				return {};
			}
		},
		questionIndex: {
			type: Number,
			default() {
				return null;
			}
		},
		reset: {
			type: Boolean,
			default() {
				return false;
			}
		}
	},
	data() {
		return {
			answer: '',
			isCorrect: false,
			isAnswered: false,
			option: ''
		};
	},
	watch: {
		isCorrect() {
			if (!this.isAnswered) {
				if (this.isCorrect) {
					eventHub.$emit('result', 1);
				} else if (!this.isCorrect) {
					eventHub.$emit('result', 0);
				}
				this.isAnswered = true;
				return true;
			}

			if (this.isAnswered) {
				if (this.isCorrect) {
					eventHub.$emit('result', 1);
				} else if (!this.isCorrect) {
					eventHub.$emit('result', -1);
				}
			
				this.isAnswered = true;
				return true;
			}
			return true;
		},
		answer() {},
		reset(val) {
			if (val) {
				this.isCorrect = false;
				this.isAnswered = false;
			}
		}
	},
	methods: {
		setAnswer(answer, option) {
			this.isCorrect = answer === this.question.answer;
			this.option = option;
		}
	}
};
</script>
